<mat-button-toggle-group multiple (change)="onChange($event)">
    <mat-button-toggle *ngFor="let gender of genders" value="{{gender.key}}">{{gender.value}}</mat-button-toggle>
</mat-button-toggle-group>
